import { IonButton, IonCol, IonRow, IonText } from "@ionic/react";
import { useDispatch } from "react-redux";
import { setSegmentSelected, setShowMassiveSign } from "../../../store/documentsSignerList";
import { useHistory } from "react-router";

const colStyle = {
  maxWidth: "450px",
  padding: "20px",
};

export const WithoutDocuments = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleGoToAgreements = () => {
    dispatch(setSegmentSelected("signed"));
    dispatch(setShowMassiveSign(false));
    history.replace("/app/acuerdos/firma/");
  };
  return (
    <>
      <IonRow class="ion-justify-content-center">
        <IonText class="ion-text-center">
          <h4>NO HAY ACUERDOS PENDIENTES</h4>
        </IonText>
      </IonRow>
      <IonRow class="ion-justify-content-around">
        <IonCol class="ion-text-center" style={colStyle}>
          <IonText color="primary">
            Felicitaciones. No se encuentran documentos pendientes de firmar.
          </IonText>
          <br />
          <br />
          <IonButton onClick={handleGoToAgreements}>Ir a acuerdos</IonButton>
        </IonCol>
      </IonRow>
    </>
  );
};
